import React, { useState, useEffect, useCallback } from "react";
import { graphql, useLazyLoadQuery } from "react-relay";
import Overlay from "../Overlay";
import DraftkingsOverlaySlateList from "./DraftKingsOverlaySlateList";
import "./DraftKingsInfoOverlay.css";

import { ReactComponent as XMark } from "../../assets/icons/x-mark.svg";

export default function DraftkingsInfoOverlay(props) {
  const escFunction = useCallback((event) => {
    if (event.keyCode === 27) {
      //Close when esc is pressed
      props.close();
    }
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", escFunction, false);

    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };
  }, []);

  const [fetchNum, setFetchNum] = useState(0);

  useEffect(() => {
    setFetchNum(fetchNum + 1);
  }, [props.show]);

  return (
    <Overlay show={props.show} adjustMargin={true}>
      {props.show ? (
        <div className="dk-info-overlay">
          <XMark
            className="feature-icon"
            fill="black"
            onClick={props.close}
            style={{ cursor: "pointer" }}
          />

          <React.Suspense fallback={<p>Loading slates...</p>}>
            <DraftkingsOverlaySlateList
              playerId={props.playerId}
              fetchNum={fetchNum}
            />
          </React.Suspense>
        </div>
      ) : null}
    </Overlay>
  );
}
